import { useState } from 'react';
import { subscribeToNewsletter } from '../api/newsletterSubscriptionsApi';
import { validateEmail } from '../utils/validateEmail';

export const useNewsletterSubscribe = (source) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formError, setFormError] = useState('');
  const [fieldError, setFieldError] = useState('');

  const handleEmailChange = (value) => {
    setEmail(value);
    if (fieldError) {
      setFieldError('');
    }
    if (formError) {
      setFormError('');
    }
    if (isSuccess) {
      setIsSuccess(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError('');
    setIsSuccess(false);

    const emailValidationError = validateEmail(email);
    if (emailValidationError) {
      setFieldError(emailValidationError);
      return;
    }

    setFieldError('');
    setIsSubmitting(true);

    try {
      await subscribeToNewsletter({
        email: email.trim(),
        source,
      });

      setIsSuccess(true);
      setEmail('');
    } catch (error) {
      if (error.errors?.length) {
        setFormError(error.errors.join(' '));
      } else {
        setFormError(error.message || 'Something went wrong. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    email,
    setEmail: handleEmailChange,
    isSubmitting,
    isSuccess,
    formError,
    fieldError,
    handleSubmit,
  };
};
